import React from "react";
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGetCategoriesQuery } from "../slices/categoryApiSlice";

const ProductCategory = () => {
  const navigate = useNavigate();
  const { data: categories, isLoading, error } = useGetCategoriesQuery();

  const handleCategoryClick = (categoryName) => {
    navigate(`/product-reference/${categoryName}`);
  };

  const colors = [
    "#007bff", "#6c757d", "#28a745", "#dc3545",
    "#ffc107", "#17a2b8", "#343a40"
  ];

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4">Choose a Category</h2>

      {isLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <Alert variant="danger" className="text-center">
          Failed to load categories.
        </Alert>
      ) : (
        <Row className="g-3 justify-content-center">
          {categories?.map((item, index) => (
            <Col
              key={item._id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="d-flex justify-content-center"
            >
              <Button
                onClick={() => handleCategoryClick(item.name)}
                style={{
                  backgroundColor: colors[index % colors.length],
                  borderColor: colors[index % colors.length],
                  width: "100%",
                }}
                className="py-3"
              >
                {item.name}
              </Button>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default ProductCategory;